<template>
  <tbody>
    <tr class="m-table-admin__row">
      <td class="m-table-admin__col">
        <div class="business-list__name">
          <div class="business-list__picture" v-if="business.ImageUri">
            <img class="business-list__picture-image" :src="business.ImageUri" :alt="business.Name" />
          </div>
          <a :href="business.Url" target="_blank">{{ business.Name }}</a>
          <span v-if="!isPublish" class="business-list__name-flag">{{ $t('business-publish-status-draft') }}</span>
        </div>
      </td>
      <td class="m-table-admin__row">
        <span v-if="business.PhoneNumber">{{ business.PhoneNumber }}</span>
      </td>
      <td class="m-table-admin__row">
        <span v-if="business.Region">{{ region() }}</span>
      </td>
      <td class="m-table-admin__row">
        <span v-if="business.ProposedPlace">{{ proposedPlace() }}</span>
      </td>
      <td class="m-table-admin__col m-table-admin__col--right">
        <a :href="`mailto:${business.UserEmail}`">{{ $t('business-contact-user-cta') }}</a>
      </td>
    </tr>
    <tr class="m-table-admin__row m-table-admin__row--btn">
      <td v-if="business.IsRegistered" colspan="4" class="m-table-admin__col m-table-admin__col--right">
        <div class="business-list__actions">
          <button class="a-btn-primary a-btn-primary--small a-btn-primary--color3 a-btn-primary--ico-cancel" @click="showUnregisterPanel" type="button">
            {{ $t('unregister-btn') }}
          </button>

          <div class="o-panel" v-bind:class="{ 'o-panel--open': isUnregisterPanelOpen }">
            <div class="o-panel__head">
              <h2 class="o-panel__title">{{ $t('unregister-confirmation-title') }}</h2>
              <button type="button" class="o-panel__close" @click="hideUnregisterPanel">{{ $t('panel-close') }}</button>
            </div>
            <div class="o-panel__content">
              <p class="m-form-group__note m-form-group__note--small">
                {{ $t('unregister-confirmation-note') }}
              </p>
              <confirmation-popup :text="$t('unregister-confirmation-text')" :actions="unregisterActions" />
            </div>
          </div>

          <div class="o-panel__overlay" @click="hideUnregisterPanel"></div>
        </div>
      </td>
      <td colspan="5" class="m-table__col m-table-admin__row--btn m-table-admin__col--right">
        <button class="a-btn-primary a-btn-primary--small" @click="editBusiness" type="button">{{ $t('business-edit-btn') }}</button>
      </td>
    </tr>
  </tbody>
</template>

<script>
import ConfirmationPopup from '@/components/popup/confirmation-popup'
import LoaderService from '@/services/loader'
import BusinessService from '@/services/business'
import router from '@/router'

import { REGION_LABELS } from '@/helpers/region-labels'
import { URL_EDIT_BUSINESS } from '@/consts/urls'
export default {
  components: {
    ConfirmationPopup
  },
  props: {
    business: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isUnregisterPanelOpen: false,
      unregisterActions: [
        { key: 'authorizeGathering_yes', label: this.$t('popup_confirm_label'), click: this.unregisterBusiness },
        { key: 'authorizeGathering_no', label: this.$t('popup_dismiss_label'), click: this.hideUnregisterPanel }
      ]
    }
  },
  methods: {
    proposedPlace() {
      return this.$t(`proposed-place-${this.business.ProposedPlace}-label`)
    },
    region() {
      return this.$t(REGION_LABELS[this.business.Region])
    },
    hideUnregisterPanel() {
      this.isUnregisterPanelOpen = false
    },
    showUnregisterPanel() {
      this.isUnregisterPanelOpen = true
    },
    async unregisterBusiness() {
      LoaderService.showLoader()
      let request = {
        businessId: this.business.Id
      }
      let business = await BusinessService.unregisterBusiness(request)
      this.$emit('businessUpdated', business)
      LoaderService.hideLoader()
    },
    editBusiness: function() {
      router.push({
        name: URL_EDIT_BUSINESS,
        params: { id: this.business.Id }
      })
    }
  },
  computed: {
    isPublish: function() {
      return this.business.IsPublish
    }
  }
}
</script>

<style lang="scss">
.business-list {
  &__name {
    align-items: center;
    display: flex;
  }

  &__picture {
    border-radius: 50%;
    height: 60px;
    margin-right: 35px;
    overflow: hidden;
    position: relative;
    width: 60px;

    &-image {
      display: block;
      left: 50%;
      max-height: 60px;
      //min-height: 100%;
      //min-width: 100%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  &-flag {
    color: #ea5244;
    padding-left: 10px;
    font-style: italic;
    font-size: 18px;
  }
}
</style>
